module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Regular.452e709f.eot";